import { observer } from "mobx-react";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import PasswordContainer from "../../components/ScreenChangePassword/ChangePasswordForm";
import Layout from "../../components/UI/Layouts";
import Content from "../../components/UI/Layouts/Content";
import { useStores } from "../../hooks/useStores";

const ForgotPassword: React.FC = observer(() => {
  const { session } = useStores();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const [email, setEmail] = useState<string | null>("");
  const [token, setToken] = useState<string | null>("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setEmail(searchParams.get("email"));
    setToken(searchParams.get("token"));
  }, [location]);

  const handleSubmitForm = useCallback(
    async (newPassword: string) => {
      try {
        if (!token) {
          throw new Error("Missing token");
        }

        if (!email) {
          throw new Error("Missing email");
        }

        await session.changePassword(email, newPassword, token);

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("email");
        searchParams.delete("token");
        history.replace({
          pathname: location.pathname,
          search: searchParams.toString(),
        });

        enqueueSnackbar(t("common.actionExecutedSuccessfully"), {
          variant: "success",
        });
      } catch (err: any) {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      }
    },
    [token, session, email, t, location, history]
  );

  return (
    <Layout hideSidebar={true} hideFooter>
      <Content fullHeight align="center">
        <PasswordContainer handleSubmitForm={handleSubmitForm} />
      </Content>
    </Layout>
  );
});

export default ForgotPassword;
